import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class ProductSettingService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 673
     * @datataskName sp_ws_p2_productsetting_list
     * @returns promise containing list of product items.
     */
    public getProductSettings(params?: GetProductSettingsParams): Promise<ProductSettingItem[]> {
        return this.datatask.Post(673, params);
    }

    /**
     * @datatask 674
     * @datataskName sp_ws_p2_productsetting_get
     * @returns promise containing the product setting.
     */
    public async getProductSetting(params: GetProductSettingParams): Promise<ProductSettingGet> {
        return (await this.datatask.Post(674, params))[0];
    }

    /**
     * @datatask 3065
     * @datataskName sp_ws_p2_productcreate_productsettingmcs_list
     * @param params
     * @returns
     */
    public async getProductCreatePimFields(params: GetProductCreatePimFieldsParams): Promise<ProductSettingMcsInput[]> {
        return this.datatask.Post(3065, params);
    }

    /**
     * @datatask 3568
     * @datataskName sp_ws_p2_product_productsettingmcitems_list
     * @param params
     * @returns
     */
    public async getPimFieldsItems(params: GetProductCreatePimFieldsParams): Promise<{ [key: string]: ProductSettingMcItem[] }> {
        return this.datatask.Post(3568, params);
    }

    /**
     * @datatask 3138
     * @datataskName sp_ws_p2_product_productsettingmcs_list
     * @param params
     * @returns
     */
    public async getProductPimFields(params: GetProductPimFieldsParams): Promise<ProductSettingMcsInput[]> {
        return this.datatask.Post(3138, params);
    }

    /**
     * @datatask 3139
     * @datataskName sp_ws_p2_product_pimdata_save
     * @param params
     * @returns
     */
    public async saveProductPimData(params: SaveProductPimDataParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3139, params))[0];
    }

    /**
     * @datatask 3558
     * @datataskName sp_ws_p2_productcreate_productsettingmc_counter
     * @param params the product setting keyno to get meta column counter for.
     * @returns promise containing the next number.
     */
    public async getProductCreateMetaColumnCounter(params: GetProductCreateMetaColumnCounterParams): Promise<ProductCreateMetaColumnCounterResponse> {
        return (await this.datatask.Post(3558, params))[0];
    }
}

export interface ProductCreateMetaColumnCounterResponse {
    nextnumber: string;
}

export interface GetProductCreateMetaColumnCounterParams {
    productsettingmc_keyno: string | number;
}

export interface GetProductCreatePimFieldsParams {
    productsetting_keyno: string | number;
}

export interface GetProductPimFieldsParams {
    productsetting_keyno: string | number;
    prod_id: string;
    language_id: string;
}

export interface ProductSettingMcsInput {
    productsettingmc_keyno: string;
    productsetting_keyno: string;
    metacolumn_keyno: string;
    default_value: string;
    prefix_value: string;
    orderby: string;
    colname: string;
    elementtype: string;
    isrequired: '1' | '0';
    build_product_name: '1' | '0';
    field_name: string;
    field_value: string;
    protected: '1' | '0';
    build_prod_id: '1' | '0';
    prod_id_length: string;
    prod_id_prefix: string;
    prod_id_postfix: string;
}

export interface ProductSettingMcItem {
    productsettingmcitem_keyno: string;
    productsettingmcitem_name: string;
    orderby: number | string;
}

export interface UnitItem {
    unit_no: string;
    qtyfactor_name: string;
    unit_no_to: string;
    qtyfactor: string;
    orderby: string;
    qtyfactor_name_inverse: string;
    inversevalue: string;
    conversion_formula: string;
    conversion_formula_replaced: string;
}

export interface GetProductSettingParams {
    productsetting_keyno: string | number;
}

export interface ProductSettingGet {
    productsetting_keyno: string;
    productsetting_name: string;
    prodtype_no: string;
    stock_unit_no: string;
    prodgrp_id: string;
    prodgrp2_id: string;
    prodgrp3_id: string;
    prodgrp4_id: string;
    businessco_no: string;
    pohcompletionmethod_keyno: string;
    pohcompletionprinciple_keyno: string;
    planpolicy_no: string;
    warning_on_pick_as_component_outside_structure: '1' | '0';
    manage_stockquantity_pr_batch: '1' | '0';
    prodplace_id: string;
    prodbeomethod_no: string;
    stockcount_unit_no: string;
    purch_price_unit_no: string;
    sales_price_unit_no: string;
    purch_number_unit_no: string;
    protected_prod_name: '1' | '0';
    show_drawing_no: '1' | '0';
    discgrpprod_keyno: string;
    unique_counter_autoproductean: '1' | '0';
}

export interface GetProductSettingsParams {
    prodtype_no?: string | number;
}

export interface ProductSettingItem {
    item_id: string;
    item_name: string;
    item_path: string;
    item_state: string;
    item_parms: string;
    orderby: string;
}

export interface SaveProductPimDataParams {
    prod_id: string;
    productsetting_keyno: string;
    language_id: string;
    metacolumns: ProductSettingMcsInput[];
}
